import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBedsideUsbCharging32 = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 18,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0v10h1a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1H9.5v3h-1v-3H1a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h1V0h14Zm1 11H1v17h16V11Zm-7.276 3.053a.5.5 0 0 1 .256.587l-.033.084L7.81 19H11a.5.5 0 0 1 .479.646l-.032.078-2.5 5a.5.5 0 0 1-.927-.364l.033-.084L10.19 20H7a.5.5 0 0 1-.478-.646l.03-.078 2.5-5a.5.5 0 0 1 .672-.223ZM15 .999H3v9h12v-9ZM7 4v3H6V4h1Zm5 0v3h-1V4h1Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgBedsideUsbCharging32;